import React, { useState } from 'react';
import styled from 'styled-components';
import { MaterialAliasData } from '../../../shared/dto/EntityRepository';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';
import { useAdminMaterialAliasStore } from '../../share/store/adminMaterialAliasStore';

interface MaterialAliasInfoProps {
  data: MaterialAliasData;
  isSelected: boolean;
  handleClick: () => void;
}

const MaterialAliasInfo: React.FC<MaterialAliasInfoProps> = ({
  data,
  isSelected,
  handleClick,
}) => {
  const activeAlias = useAdminMaterialAliasStore((state) => state.activeAlias);
  const [hovered, setHovered] = useState(false);

  return (
    <MaterialAliasInfoComp
      data-material-alias-id={data.id}
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <ContentWrapper>
        <TitleBlock $isHover={hovered} $isActive={isSelected}>
          <TitleText>{data.keyword}</TitleText>
        </TitleBlock>
        <AdminBlockWithVisible
          width="1"
          value={String(data.frequency)}
          isHover={hovered}
          isActive={isSelected}
        />
        <AdminBlockWithVisible
          width="2"
          value={data.aliasSet?.material ?? 'Unassigned'}
          isHover={hovered}
          isActive={isSelected}
        />
        {activeAlias && <SpaceBlock />}
      </ContentWrapper>
    </MaterialAliasInfoComp>
  );
};

const MaterialAliasInfoComp = styled.article`
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  min-height: 40px;
  cursor: pointer;

  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const TitleBlock = styled.div<{ $isHover: boolean; $isActive: boolean }>`
  flex: 2.4;
  min-width: 0;
  display: flex;
  align-items: center;
  padding-left: 10px;
  text-decoration: ${({ $isActive }) => ($isActive ? 'underline' : 'none')};
  background-color: ${({ theme, $isHover, $isActive }) =>
    $isActive ? theme.colors.color_Gray_06 : $isHover ? theme.colors.color_Gray_07 : 'transparent'};
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.color_Gray_04};
  cursor: pointer;
`;

const TitleText = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SpaceBlock = styled.div`
  flex: 0.15;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: auto;
`;

export default MaterialAliasInfo;
